export enum StepStatus {
  INPROGRESS = 'In Progress',
  PENDING = 'Pending',
  DONE = 'Done',
  ERROR = 'Error'
}

export interface StepProps {
  status: StepStatus;
}
